module.exports = __webpack_public_path__ + "img/entry-bg.99871d5b.png";